import Modal from 'bootstrap/js/dist/modal';

document.querySelectorAll('body:not(.page-id-21) main a[href*="/glossaire/"]:not(.btn):not(.href)').forEach((el) => {
	el.addEventListener('click', (event) => {
		event.preventDefault();

		let _data = {
			action: 'glossary_word',
			href: el.href
		};

		fetch("/wp-admin/admin-ajax.php", {
			method: 'POST',
			body: (new URLSearchParams(_data)).toString(),
			headers: { 'Content-type': 'application/x-www-form-urlencoded' }
		})
		.then(response => response.text()).then(response => {
			var modalElement = document.createElement('template');
			modalElement.innerHTML += response;
			document.body.appendChild(modalElement.content);

			let modalDom = document.getElementById('modal-glossary');
			let modal = new Modal(modalDom, {});
			modal.show();

			modalDom.addEventListener('hidden.bs.modal', event => {
				modalDom.remove();
			})
		});
	})
});